import {Mapper} from '@s-ui/domain'

export class FromPostResponseToCommentIdEntityMapper extends Mapper {
  constructor({commentIdEntityFactory}) {
    super()

    this._commentIdEntityFactory = commentIdEntityFactory
  }

  map = idFromResponse => {
    return this._commentIdEntityFactory({id: idFromResponse})
  }
}
